import { render, staticRenderFns } from "./infoCoefficient.vue?vue&type=template&id=5329c8f3&"
import script from "./infoCoefficient.vue?vue&type=script&lang=js&"
export * from "./infoCoefficient.vue?vue&type=script&lang=js&"
import style0 from "./infoCoefficient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports